'use client'

import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

// The inventory-slot frame, drawn behind every upgrade-material icon — 387
// identical `sx` objects on `arme-ninja` alone, each carrying the full
// `image-set(...)` background string.
//
// Everything except the background is fixed. The background rides in on a CSS
// custom property via the plain `style` attribute, so it costs a DOM attribute
// rather than an `sx` object in the payload.
//
// In its own `'use client'` module because `styled()` cannot be called from a
// module in the server graph.
export const SlotBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': { display: 'block', objectFit: 'contain' },
  backgroundImage: 'var(--slot-bg)',
  backgroundPosition: 'center',
  backgroundSize: '100% 100%',
  backgroundRepeat: 'no-repeat',
})
